import { useTranslation } from 'react-i18next'

import { Link } from '@tanstack/react-router'

import { ArrowLeft } from 'lucide-react'

export const Forbidden = () => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] p-6">
      <h2 className="text-xl font-bold mb-2">{t('forbidden.title')}</h2>
      <p className="text-gray-600 mb-4">{t('forbidden.description')}</p>
      <Link to="/" className="flex items-center gap-2">
        <ArrowLeft className="h-3 w-3" />
        {t('forbidden.backToHome')}
      </Link>
    </div>
  )
}
